/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'goal-actions.archive-goal.generic-error-title': '無法封存目標',
  'goal-actions.copy-goal.cancel': '取消',
  'goal-actions.copy-goal.close-modal': '關閉強制回應',
  'goal-actions.copy-goal.error': '為您的目標命名，讓大家都知道目標是什麼',
  'goal-actions.copy-goal.failed-description': '複製目標時發生錯誤，請稍後再試一次。',
  'goal-actions.copy-goal.failed-description-forbidden': '您沒有複製這個目標的權限。',
  'goal-actions.copy-goal.failed-title': '我們無法複製此目標。',
  'goal-actions.copy-goal.followers': '追蹤者',
  'goal-actions.copy-goal.goal-name': '目標名稱',
  'goal-actions.copy-goal.include': '包含',
  'goal-actions.copy-goal.links': '連結',
  'goal-actions.copy-goal.submit': '提交',
  'goal-actions.copy-goal.success-description': '已成功複製目標。',
  'goal-actions.copy-goal.success-link': '檢視已複製的目標。',
  'goal-actions.copy-goal.success-title': '已複製目標「{goalName}」。',
  'goal-actions.copy-goal.title': '複製目標',
  'goal-actions.follow-goal.follow-error-title': '無法追蹤目標',
  'goal-actions.follow-goal.unfollow-error-title': '無法取消追蹤目標',
  'goal-actions.goal-actions.archive-error-title': '目標無法復原',
  'goal-actions.goal-actions.archive-goal': '封存目標',
  'goal-actions.goal-actions.archive-restore-error-description': '目標變更無法儲存，請稍後再試一次。',
  'goal-actions.goal-actions.copy-goal': '複製目標',
  'goal-actions.goal-actions.copy-link': '複製連結',
  'goal-actions.goal-actions.follow': '追蹤',
  'goal-actions.goal-actions.generic-error-description': '發生錯誤，請在幾分鐘後再試一次。',
  'goal-actions.goal-actions.restore-goal': '復原目標',
  'goal-actions.goal-actions.share': '分享',
  'goal-actions.goal-actions.show-more': '顯示較多',
  'goal-actions.goal-actions.unfollow': '取消追蹤',
  'goal-actions.goal-content.follow-confirmation-description':
    '我們會向您傳送摘要，其中包含您在下個月第一週所追蹤的所有目標更新資訊。',
  'goal-actions.goal-content.follow-confirmation-title': '🙌🏼 您現已追蹤此目標！',
  'goal-actions.restore-goal.generic-error-title': '無法復原目標',
};
